export const POSITION_ROLES = [
  'Кухар',
  'Посудомийка',
  'Прибиральниця',
  'Бармен',
  'Офіціант',
  'Працівник',
  'Адміністратор',
  'Шеф кухар',
  'ШефКухар',
  'Керівник',
] as const;
